import React, { Suspense } from 'react'
import { Outlet } from 'react-router'

import AuthGuard from '@/components/guards/AuthGuard'
import ClientReferralsPageHeader from '@/components/layouts/DashboardLayout/CompanyDashboardClientReferralsLayout/components/ClientReferralsPageHeader'
import CompanyDashboardLayout from '@/components/layouts/DashboardLayout/CompanyDashboardLayout'
import { USER_TYPE } from '@/types/misc'

const CompanyDashboardClientReferralsLayout: React.FC = () => (
  <AuthGuard requiredUserType={USER_TYPE.company}>
    <CompanyDashboardLayout padded>
      <div className="mw-lg">
        <ClientReferralsPageHeader />

        {/*
        The `null` fallback is intentional as we don't want to show anything
        whilst the route code is being imported. The route code import happens
        very quickly so showing a fallback doesn't make a sense and only adds
        a flicker.
        */}
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </div>
    </CompanyDashboardLayout>
  </AuthGuard>
)

export default CompanyDashboardClientReferralsLayout
